import Vue from 'vue'
import { Button, Container, Header, Main, Footer, Card, Row, Col, Link, Image } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

locale.use(lang)

Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Link)
Vue.use(Image)
